/**
 * Aiká — Hotspots sincronizados com carrossel de produtos
 * Clicar num ponto na imagem rola o carrossel até o card daquele produto.
 * Rolar o carrossel destaca automaticamente o ponto do produto visível.
 *
 * Tamanho do card do carrossel:
 * - Desktop (imagem e carrossel lado a lado): altura vem da imagem,
 *   largura é derivada dela — como sempre foi.
 * - Mobile (imagem e carrossel empilhados): a altura da imagem não tem
 *   relação nenhuma com o espaço horizontal disponível do carrossel, e
 *   usar ela cortava o card. Aqui o cálculo é invertido: a largura vem
 *   do espaço realmente disponível na tela, e a altura é derivada dela.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.aika-hotspot').forEach((section) => {
    const imageRef = section.querySelector('[data-hotspot-image-ref]');
    const body = section.querySelector('[data-hotspot-carousel-body]');
    const track = section.querySelector('[data-carousel-track]');
    const inner = section.querySelector('.aika-hotspot__carousel-inner');
    const arrows = section.querySelectorAll('.aika-hotspot__arrow');
    const cards = track ? Array.from(track.querySelectorAll('[data-carousel-item]')) : [];
    const dots = Array.from(section.querySelectorAll('[data-hotspot-index]'));

    if (!imageRef || !body || !track || !cards.length) return;

    const CARD_GAP = 10; // precisa bater com o "gap" do .aika-hotspot__card no CSS
    const MOBILE_BREAKPOINT = 768;

    const getTextHeight = (card) => {
      const title = card.querySelector('.aika-hotspot__card-title');
      const footer = card.querySelector('.aika-hotspot__card-footer');
      return (
        (title ? title.getBoundingClientRect().height : 0) +
        (footer ? footer.getBoundingClientRect().height : 0) +
        CARD_GAP * 2
      );
    };

    const syncCarouselSizeMobile = () => {
      if (!inner) return;
      let arrowsWidth = 0;
      arrows.forEach((arrow) => {
        arrowsWidth += arrow.getBoundingClientRect().width;
      });
      const innerGap = 12;
      const gapsWidth = arrowsWidth > 0 ? innerGap * 2 : 0;
      const containerWidth = inner.getBoundingClientRect().width - arrowsWidth - gapsWidth;
      if (containerWidth <= 0) return;

      const textHeight = getTextHeight(cards[0]);
      const imageHeight = containerWidth * (5 / 4);
      const totalHeight = imageHeight + textHeight;

      body.style.height = totalHeight + 'px';
      body.style.width = containerWidth + 'px';

      cards.forEach((card) => {
        card.style.width = containerWidth + 'px';
      });
    };

    const syncCarouselSizeDesktop = () => {
      const totalHeight = imageRef.getBoundingClientRect().height;
      if (totalHeight === 0) return;

      const textHeight = getTextHeight(cards[0]);
      const imageHeight = Math.max(totalHeight - textHeight, 40);
      const cardWidth = imageHeight * (4 / 5);

      body.style.height = totalHeight + 'px';
      body.style.width = cardWidth + 'px';

      cards.forEach((card) => {
        card.style.width = cardWidth + 'px';
      });
    };

    const syncCarouselSize = () => {
      if (window.innerWidth < MOBILE_BREAKPOINT) {
        syncCarouselSizeMobile();
      } else {
        syncCarouselSizeDesktop();
      }
    };

    syncCarouselSize();

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncCarouselSize, 150);
    });

    if (window.ResizeObserver) {
      new ResizeObserver(syncCarouselSize).observe(imageRef);
    }

    if (!dots.length) return;

    const setActive = (index) => {
      dots.forEach((dot) => {
        dot.classList.toggle('is-active', dot.dataset.hotspotIndex === String(index));
      });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.hotspotIndex, 10);
        const card = cards[index];
        if (card) {
          const cardLeft = card.offsetLeft - track.offsetLeft;
          track.scrollTo({ left: cardLeft, behavior: 'smooth' });
        }
        setActive(index);
      });
    });

    const updateActiveFromScroll = () => {
      const trackRect = track.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;

      cards.forEach((card, index) => {
        const cardRect = card.getBoundingClientRect();
        const cardCenter = cardRect.left + cardRect.width / 2;
        const distance = Math.abs(cardCenter - trackCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      setActive(closestIndex);
    };

    track.addEventListener('scroll', updateActiveFromScroll, { passive: true });
    updateActiveFromScroll();
  });
});
